import DealerLocator from "../../vue/DealerLocator/DealerLocator.vue";
import { t } from "../utils/filters";
import Vue from 'vue';
import VueEvents from "vue-events";
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBgTOWF_K2rLqKO2o0TQDsZ4fCMhFZwDt0',
        libraries: 'places',
    },
    installComponents: true
});
Vue.use(VueEvents);

const main = async () => {
    Vue.filter('t', t);

    const vm = new Vue({
        el: "#dealer-locator",
        components: {
            'dealer-locator': DealerLocator,
        },
        data: {},
        methods: {},
        mounted() {
        },
    });
};

// Execute async function
main().then(() => {
});